import {svgIconWrapper} from '../svg-icon-wrapper';

import MessageSquareQuote from './message-square-quote-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <MessageSquareQuote {...props} />;
}
SvgComponent.iconName = 'messageSquareQuote';

export const MessageSquareQuoteIcon = svgIconWrapper(SvgComponent);
